import { render, staticRenderFns } from "./EmpleadoEdit.vue?vue&type=template&id=34d4f2c0&scoped=true&"
import script from "./EmpleadoEdit.vue?vue&type=script&lang=js&"
export * from "./EmpleadoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d4f2c0",
  null
  
)

export default component.exports